import { render, staticRenderFns } from "./VesselForm.vue?vue&type=template&id=4fedec80&"
import script from "./VesselForm.vue?vue&type=script&lang=js&"
export * from "./VesselForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports